import { useState } from 'react';

import { useTranslation } from '@sshop/i18n';

import { backendAssetUrl } from '@/shared/lib/backendAssetUrl';

import { useAuthSession } from '../useAuthSession';
import { setSocialAuthReturnPath } from '../socialAuthReturn';

import { socialAuthButtonsStyles as s } from './SocialAuthButtons.styles';
import type { SocialAuthButtonsProps } from './SocialAuthButtons.types';

export function SocialAuthButtons({ busy, onStart, returnTo }: SocialAuthButtonsProps) {
  const { t } = useTranslation('auth');
  const { provider: authProvider } = useAuthSession();
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState<'google' | 'facebook' | null>(null);

  const start = async (which: 'google' | 'facebook') => {
    setError(null);
    setPending(which);
    onStart?.(which);
    try {
      const url = await authProvider.socialRedirectUrl(which);
      setSocialAuthReturnPath(returnTo ?? null);
      window.location.href = url;
    } catch {
      setError(t('socialFailed'));
      setPending(null);
    }
  };

  const disabled = busy === true || pending !== null;

  return (
    <div className={s.root}>
      <button
        type="button"
        className={s.button}
        disabled={disabled}
        onClick={() => void start('google')}
      >
        <img
          className={s.icon}
          src={backendAssetUrl('/client/assets/images/signin/2.png')}
          alt=""
        />
        <span>{pending === 'google' ? t('redirecting') : t('continueWithGoogle')}</span>
      </button>
      {error && <p className={s.error}>{error}</p>}
    </div>
  );
}
